import * as React from "react";
import PropTypes from "prop-types";

import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import { FormTextField } from "ui/Form";

import {
  UPDATE_ACCOUNT_NOTE,
  READ_ACCOUNT_NOTES_QUERY,
} from "graphqlQueries/accounts";

import { noteValidator } from "validators/noteValidator";

import { getQueryName } from "utils/getQueryName";

const UpdateAccountNote = ({ idNote, text, ...otherProps }) => {
  const readAccountNotesQueryName = React.useMemo(
    () => getQueryName(READ_ACCOUNT_NOTES_QUERY),
    [],
  );
  const initialValues = React.useMemo(
    () => ({
      text,
      id_note: idNote,
    }),
    [],
  );

  return (
    <DialogFormWithMutation
      mutationQueries={UPDATE_ACCOUNT_NOTE}
      refetchQueries={[readAccountNotesQueryName]}
      initialValues={initialValues}
      validationSchema={noteValidator}
      title="Edit note"
      submitButtonName="Save"
      className="dialog-default-width"
      {...otherProps}
    >
      <FormTextField name="text" label="Text" />
    </DialogFormWithMutation>
  );
};

UpdateAccountNote.propTypes = {
  idNote: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
};

export default UpdateAccountNote;
